module.exports = __webpack_public_path__ + "img/adv_ykf.31c2a400.png";